export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 4_06.c0d08a0f.jpg";